import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, CodeEditor, Multilingual, DropdownSelector, RadioButtonSelector } from 'hyperdb-utils';

const MultilingualText = Multilingual(TextInput);
const MultilingualEditor = Multilingual(CodeEditor);

class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.api.emailTemplate.getData({
      url: '/types',
      propName: 'templateTypes',
    });
  }
  render() {
    return (
      <fieldset>
        <DropdownSelector
          label="Type *"
          name="type"
          options={ this.typesOptions(this.props.templateTypes || []) }
          value={ this.props.objectData.type }
          onChange={ this.handleChange.bind(this, 'type') }
        />
        <TextInput
          label="Name *"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <MultilingualText
          label="Subject"
          name="subject"
          value={ (this.props.objectData.subject || {}).$i18n }
          onChange={ this.handleChangeLocalized.bind(this, 'subject') }
          availableLocales={ this.props.availableLanguages }
        />
        <RadioButtonSelector
          label="Mode"
          name="mode"
          options={ [{ name: 'markdown', value: 'markdown' }, { name: 'html', value: 'html' }] }
          value={ this.props.objectData.mode || 'markdown' }
          onChange={ this.handleChange.bind(this, 'mode') }
        />
        <MultilingualEditor
          mode={ this.props.objectData.mode || 'markdown' }
          label="Body"
          name="body"
          value={ (this.props.objectData.body || {}).$i18n }
          onChange={ this.handleChangeLocalized.bind(this, 'body') }
          availableLocales={ this.props.availableLanguages }
        />
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
  handleChangeLocalized(attributeName, field) {
    const { name, value } = field;
    const localized = { $i18n: field.value };
    this.props.updateEditedObject({ attributeName, value: localized });
  }
  typesOptions(templateTypes) {
    return templateTypes.sort((a, b) => a.code - b.code).map(t => {
      return { name: `${t.code} - ${t.type}`, value: t.code };
    });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default HyperdbForm(Form, {
  namespace: 'emailTemplate',
  mountedUrl: '/email/templates',
  titleNew: 'Create new template',
  titleEdit: 'Edit template',
  displayName: (object) => object.name,
  checkIsValid: (props) => {
    return !!props.objectData.type && !!props.objectData.name;
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/template/containers/Form.jsx